//@flow
import * as React from "react";
import styled from "react-emotion";
import { theme, mqMin } from "../../styles/theme";
import PageProgress from "../PageProgress";
import ScrollNotifier from "../ScrollNotifier";
import ProfilePic from "../ProfilePic";
import { toHtml } from "../../utilities";

const Grid = styled.div`
  display: flex;
  padding-top: ${theme.space2};
  padding-bottom: ${theme.space5};
  flex-direction: column;
  justify-content: space-evenly;
  max-width: ${theme.maxWidth3};
  margin-left: auto;
  margin-right: auto;
  ${mqMin(theme.tablet)} {
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

const Cell = styled.div`
  width: 100%;
  padding: ${theme.space3};
  ${mqMin(theme.tablet)} {
    max-width: 375px;
    padding: 0 ${theme.space3};
    margin-top: ${props => props.offset * 40}px;
  }
`;

const findMember = (team, name) =>
  team.filter(e => e.node.data.name === name)[0];

const teamEdgeToProps = edge => {
  return {
    heading: edge.node.data.name,
    text: edge.node.data.bio.html,
    meta: edge.node.data.type_of_work,
    scrollingImages: [
      edge.node.data.moving_1.url,
      edge.node.data.moving_2.url,
      edge.node.data.moving_3.url
    ],
    profileImage: edge.node.data.primary_pic.url,
    webpage: edge.node.data.webpage.url,
    webpageName: edge.node.data.webpage_name
  };
};
export default ({ team }) => {
  if (!team) {
    return null;
  }
  return (
    <PageProgress>
      {({ progress }) => (
        <div>
          <Grid progress={progress}>
            <ScrollNotifier onEnter="TEAM_1" offset="0" />
            <Cell offset={0}>
              <ProfilePic
                key={0}
                {...teamEdgeToProps(findMember(team, "Brenda Perks"))}
                progress={progress}
              />
            </Cell>
            <Cell offset={1}>
              <ProfilePic
                key={1}
                {...teamEdgeToProps(findMember(team, "Mike Joslyn"))}
                progress={progress}
              />
              <ScrollNotifier onEnter="TEAM_2" offset="-20%" />
            </Cell>

            <Cell offset={2}>
              <ProfilePic
                key={2}
                {...teamEdgeToProps(findMember(team, "Spencer Timkey"))}
                progress={progress}
              />
            </Cell>
            <Cell offset={3}>
              <ProfilePic
                key={3}
                {...teamEdgeToProps(findMember(team, "Ashley Baron"))}
                progress={progress}
              />

              <ScrollNotifier onEnter="TEAM_3" offset="-20%" />
            </Cell>
            <Cell offset={4}>
              <ProfilePic
                key={4}
                {...teamEdgeToProps(findMember(team, "Jaimie Woodarek"))}
                progres={progress}
              />
              <ScrollNotifier onEnter="TEAM_3" offset="-50%" />
            </Cell>
          </Grid>
        </div>
      )}
    </PageProgress>
  );
};



// WEBPACK FOOTER //
// ./src/components/Team/index.js